import { ColumnDefinitionV3, ColumnRendererComponentV3 } from '@gea/digital-ui-lib';
import { FaultCatalogType, Annunciation, AnnunciationTree } from '@shared/models';
import {
  LastInstanceRendererComponent,
  TextSolvedRenderComponent,
  LinkButtonRendererComponent,
  ProgressBarRendererComponent,
} from './renderer';

export const Fix_ACTION = 'fix-action';

interface HierarchyColumnConfig {
  totalCountColor: string;
  displayNamePercentage: string;
}

const createColumnDefinitions = (config: HierarchyColumnConfig): ColumnDefinitionV3[] => [
  {
    key: 'faultName',
    displayName: 'FAULT_ANALYSIS.COMMON_TABLE_HEADERS.FAULT_NAME',
    width: 300,
  },
  {
    key: 'machineName',
    displayName: 'FAULT_ANALYSIS.COMMON_TABLE_HEADERS.MACHINE',
  },
  {
    key: 'timeStamp',
    displayName: 'FAULT_ANALYSIS.COMMON_TABLE_HEADERS.ISSUED',
    renderer: {
      component: LastInstanceRendererComponent as ColumnRendererComponentV3<Annunciation>,
    },
  },
  {
    key: 'solved',
    displayName: 'FAULT_ANALYSIS.COMMON_TABLE_HEADERS.SOLVED',
    renderer: {
      component: LastInstanceRendererComponent as ColumnRendererComponentV3<Annunciation>,
    },
  },
  {
    key: 'countPending',
    displayName: 'FAULT_ANALYSIS.COMMON_TABLE_HEADERS.PENDING_COUNT',
  },
  {
    key: 'countSolved',
    displayName: 'FAULT_ANALYSIS.COMMON_TABLE_HEADERS.OCCURENCES',
    renderer: {
      component: TextSolvedRenderComponent as ColumnRendererComponentV3<Annunciation>,
    },
  },
  {
    key: 'countPendingRelative',
    displayName: config.displayNamePercentage,
    renderer: {
      component: ProgressBarRendererComponent as ColumnRendererComponentV3<AnnunciationTree>,
      config: {
        barHeight: 20,
        countColor: config.totalCountColor,
        totalCountColor: 'var(--geaui-light-gray)',
      },
    },
  },
  {
    key: 'actionBtn',
    sortable: false,
    displayName: '',
    renderer: {
      component: LinkButtonRendererComponent as ColumnRendererComponentV3<Annunciation>,
    },
  },
];

export const getFaultDefinitions = (type: FaultCatalogType) => {
  const config = {
    shutdown: {
      totalCountColor: 'var(--geaui-red)',
      displayNamePercentage: 'FAULT_ANALYSIS.SHUTDOWNS.TABLE_HEADERS.TOTAL_PERCENTAGE',
    },
    warning: {
      totalCountColor: 'var(--geaui-yellow)',
      displayNamePercentage: 'FAULT_ANALYSIS.WARNINGS.TABLE_HEADERS.TOTAL_PERCENTAGE',
    },
  };

  return createColumnDefinitions(config[type as 'shutdown' | 'warning']);
};
